/** @jsxImportSource @emotion/react */
import { useTheme } from "@emotion/react";
import React from "react";
import CommonNavigationBar from "components/MainComponents/NavigationBar/CommonNavigationBar";
import GeneratePasswordForm from "components/MainComponents/ChangePassword/GeneratePasswordForm";
import ForgotPasswordForm from "components/MainComponents/ChangePassword/ForgotpasswordForm";
import { useSearchParams } from "react-router-dom";

export default function ResetPasswordPage() {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const isForgotPassword = searchParams?.get('type') === 'forgot';

  return (
    <>
      <div>
        <CommonNavigationBar />
        {isForgotPassword ? <ForgotPasswordForm /> : <GeneratePasswordForm />}
      </div>
    </>
  );
}
